




















































































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import UiList from '@superUI/List/List'
import AudienceListingResourceListFilters from '@superComponents/AudienceListing/AudienceListingResourceListFilters'
import AudienceListingResourceListPrimaryFilters from '@superComponents/AudienceListing/AudienceListingResourceListPrimaryFilters'

settings =
  name: 'AudienceListingResourceList'

  vue:
    props: ['audienceListings', 'bulkActionResultItems', 'actions', 'filtersOverriden', 'infiniteWrapper', 'options']

    components: {
      Modal,
      RequestButton,
      LoadingIndicator,
      Trigger,
      ResourceList,
      UiList,
      AudienceListingResourceListFilters,
      AudienceListingResourceListPrimaryFilters,
    }

    data: ->
      activeFilter: false
      pageNumber: 1

      sortList: [
        { field: 'ctx.supplier.org.name', value: 'Organizer' }
        { field: 'ctx.owner.email', value: 'Owner' }
        { field: 'published_at', value: 'Published Date' }
        { field: 'reach', value: 'Attendance' }
        # { field: 'starts_at', value: 'Event Date' }
        # { field: 'ctx.stats.offer.count', value: '# Offers' }
        # { field: 'ctx.stats.offer.pending_count', value: '# Offers Pending' }
        # { field: 'occurrence_index', value: 'Occurrence Index' }
        # { field: 'origin', value: 'Origin' }
        # { field: 'horizon', value: 'Horizon' }
        # { field: 'created_at', value: 'Created At' }
        # { field: 'updated_at', value: 'Updated At' }
        # { field: 'potential_confirmed_at', value: 'Potential Confirmed At' }
        # { field: 'draft_at', value: 'Draft At' }
        # { field: 'listed_at', value: 'Listed at' }
        # { field: 'recess_verified_at', value: 'Recess Verified At' }
        # { field: 'recess_owner', value: 'Recess Owner' }
        # { field: 'venue.state', value: 'Venue State' }
        # { field: 'allowed_distributors', value: 'Allowed Distributors' }
        # { field: 'restrictions.food.can_be_distributed', value: 'Food Restriction' }
        # { field: 'restrictions.drink.can_be_distributed', value: 'Drink Restriction' }
        # { field: 'view_info.brand_reps.count', value: '# Views' }
      ]
      sortValue: ''

      filters:
        scopes:
          published_state: null
          # state: null
          # occurrence: null
          # origin: null
          # potential: null
          # horizon: null
          # workflow: null
          # offers: null
          # can_request_for_more_info: null

        time_windows:
          starts: { after: '', before: '' }
          # listed: { after: '', before: '' }
          # organizer_confirmed: { after: '', before: '' }
          # verified: { after: '', before: '' }

        multi_filters:
          location_state_in_list: []
          location_DMA_in_list: []

        q: ''
        sort: [{ field: 'published_at', order: 'desc' }]

      selectedFilters: []
      selectedAudienceListings: []
      rowSize: 3

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?

    computed:
      components: ->
        'audience-listing-resource-list-item': () => import('./AudienceListingResourceListItem'),

      title: ->
        @options?.title || 'Audience Listings'

      resourceKey: ->
        @options?.resourceKey || 'audience_listings'

      availableSort: ->
        # refactor
        ctx = this
        availableList = @sortList.filter((sort) ->
          item = ctx.filters.sort.find((item) -> item.field == sort.field)
          !item
        )
        availableList

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1

      hiFilterChange: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        filtersPayload = @formatFiltersPayload()
        @actions.fetchResource(null, @resourceKey, filtersPayload, { page: @pageNumber })
        @pageNumber += 1

      formatFiltersPayload: ->
        payload = { ...@filters }
        timeWindows = payload.time_windows

        payload.filters = payload.filters || {}
        for field, value of payload.filters
          delete payload.filters[field] if not value

        for k, v of payload.multi_filters
          delete payload.multi_filters[k] unless v.length

        for field, timeWindow of timeWindows
          payload.filters["#{field}_before"] = timeWindow.before if timeWindow.before
          payload.filters["#{field}_after"] = timeWindow.after if timeWindow.after

        payload

      hiSearchChange: (q = '') ->
        @filters.q = q
        @hiFilterChange(@filters)

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @selectedFilters = []
        @hiFilterChange(@filters)

      hiAddSort: (order) ->
        return false if !@sortValue.length
        @filters.sort.push({ field: @sortValue, order })
        @hiFilterChange()
        @sortValue = ''

      hiRemoveSort: (sort) ->
        @filters.sort = @filters.sort.filter((item) -> item.field != sort.field)
        @hiFilterChange(@filters)

      hiFlipOrder: (sort) ->
        newOrder = if sort.order == 'asc' then 'desc' else 'asc'
        @filters.sort = @filters.sort.filter((item) ->
          item.order = newOrder if item.field == sort.field
          item
        )
        @hiFilterChange(@filters)

      sortOrderIcon: (order) ->
        if order == 'asc'
          return 'fa-arrow-up'
        return 'fa-arrow-down'

      getFieldName: (field) ->
        @sortList.find((item) -> item.field == field).value

export default VueOptions.vue settings
